import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CrmSubmissionStatus } from '../../queries/model/crmSubmissionStatus';
import { LayoutService } from '../../core/service/layout.service';
import { RevalidationStatus } from '../model/RevalidationStatus';
import { SubmissionEnquiryService } from '../service/submissionEnquiry.service';
import { CrmRemediationStatus } from '../model/CrmRemediationStatus';
import { CrmNoirAndNorStatus } from '../../queries/model/crmNoirAndNorStatus';
import { CrmReviewAndFeedbackStatus } from '../model/CrmReviewAndFeebackStatus';
import { RevalidationItemType } from '../model/RevalidationItemType';
import { AnswerType } from '../../dynamic/model/AnswerType';
import { CompletionStatus } from '../model/CompletionStatus';
import { ExtenuatingCircumstanceReviewDecision } from '../../queries/model/ExtenuatingCircumstanceReviewDecision';
import { ExtCircType } from '../model/ExtCircType';
import { CustomErrorHandler } from '../../core/service/CustomErrorHandler';
import { Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';


@Component({
    selector: 'app-revalidation-details',
    templateUrl: './revalidation-details.component.html',
    styleUrls: ['./revalidation-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RevalidationDetailsComponent implements OnInit {

  @ViewChild('regNumber',) regNumberRef!: ElementRef;
  private search$ = new Subject<string>();

  loading = false;
  searchCriteria = {
    regNumber: '',
    date: undefined,
    status: undefined
  };
  regNo = '';
  selectedDate: any = undefined;
  heading: string = '';
  subHeading: string = '';
  displayRevalidationRecords: boolean | null = true;
  entries = [];
  revalidations: any;
  revalidationDetails: any;
  registrantName: string = '';
  expectation: any;
  revalidationSelected: any;
 
  AnswerType = AnswerType;
  exceptionalCircumstance = [];
  CompletionStatus = CompletionStatus;
  ExtenuatingCircumstanceReviewDecision = ExtenuatingCircumstanceReviewDecision;
  ExtCircType = ExtCircType;
  entryDetails: any;


  constructor(
    public layout: LayoutService,
    private service: SubmissionEnquiryService,
    public error: CustomErrorHandler,
  ) { }

  ngOnInit(): void {
    this.heading = 'Submission enquiry';
    this.setSubHeading();  
    this.search$
      .pipe(
        distinctUntilChanged()
      )
      .subscribe(regNo => {
        this.loading = true;
        this.service.getRevlidationSubmissions(regNo)
          .subscribe({
            next: details => {
              this.revalidationDetails = details;
              this.revalidations = details.revalidations;
              this.registrantName = details.registrantName;
              this.loading = false;
            },
            error: error => {
              this.loading = false;
              console.error(error);
            }
          });

        this.regNo = regNo;
        this.displayRevalidationRecords = true;
      });
  }

  search(regNum: string): void {
    if (!regNum?.trim()) {
      return;
    }

    this.search$.next(regNum);
  }
  

  getRevalidationStatus(status: number) {
    return RevalidationStatus[status];
  }

  getSubmissionStatus(status: number) {
    return CrmSubmissionStatus[status];
  }

  getRemediationStatus(status: number) {
    return CrmRemediationStatus[status];
  }

  getNoirAndNorStatus(status: number) {
    return CrmNoirAndNorStatus[status];
  }

  getReviewAndFeedbackStatus(status: number) {
    return CrmReviewAndFeedbackStatus[status];
  }

  getRevalidationItemType(type: number) {
    return RevalidationItemType[type];
  }

  clearSearch() {
    this.displayRevalidationRecords = true;
    this.searchCriteria.regNumber = this.registrantName =  '';
    this.searchCriteria.date = undefined;
    this.revalidations = [];
  }

  setYearSelected(date: string) {
    this.selectedDate = date;
    this.revalidationSelected = this.revalidations.filter((revalidation: any) => revalidation.renewalDate === date)[0];
    this.entries = this.revalidations.filter( (revalidation: any) => revalidation.renewalDate === date)[0].entries;
    this.expectation = this.revalidations.filter( (revalidation: any) => revalidation.renewalDate === date)[0].expectation;
    this.exceptionalCircumstance = this.revalidations.filter((revalidation: any) =>revalidation.renewalDate === date)[0].exceptionalCircumstance;
    this.fetchEntriesDetails();
  }

  fetchEntriesDetails() {
    this.displayRevalidationRecords = false;
    this.setSubHeading();    
  }

  onBackBtnClick(){
    this.displayRevalidationRecords = true;
    this.search(this.regNo);
  }

  setSubHeading() {
    this.subHeading = (this.displayRevalidationRecords === true) ? 'View revalidation records': (this.displayRevalidationRecords === false ? 'View revalidation record details': '');
  }

  fetchEntryDetailsByTitle(item: any) {
  this.entryDetails = {questionGroups : item.form.questionGroups, title : item.title};
  this.displayRevalidationRecords = null;
  }
  onEntriesBackBtnClick() {
   this.fetchEntriesDetails();
  }
}
